module.exports = __webpack_public_path__ + "img/melia-beach.6df530d9.jpg";